import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/cutlery-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-1a44df5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero-main" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Azzurra", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cutlery-icon",
  alt: "",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.t('general.italianRestaurant')), 1),
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_router_link, {
      to: {name: 'Menu'},
      class: "menu-button"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('menu.viewOurMenu')), 1)
      ]),
      _: 1
    })
  ]))
}